export default __webpack_public_path__ + "static/media/man_cut.51cc709a.png";